import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import axios from "axios"; // ✅ On remplace EmailJS par Axios
import { FaFacebook, FaInstagram, FaTiktok, FaLinkedin, FaPaperPlane } from "react-icons/fa";
import Logo from "../../Asset/logo.png";
import { toast } from "react-toastify"; // Container déjà présent dans App.js (vu précédemment)
import "react-toastify/dist/ReactToastify.css";
import { 
    useColorModeValue,
    Box,
    Container,
    SimpleGrid,
    Stack,
    Text,
    Link,
    Heading,
    Input,
    IconButton,
    Image
} from "@chakra-ui/react";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      email: email,
      type: "NEWSLETTER" // On envoie le type pour que ton backend sache quoi faire
    };

    try {
      // ✅ Envoi vers TON serveur local
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      await axios.post(`${API_URL}/api/contact`, payload);
      
      toast.success("🎉 Merci pour votre inscription à la newsletter !");
      setEmail("");
    } catch (error) {
      console.error("Erreur newsletter :", error);
      toast.error("❌ Impossible de s'inscrire pour le moment.");
    } finally {
      setLoading(false);
    }
  };

  const footerBg = useColorModeValue('gray.100', 'rgb(10, 25, 45)');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const headingColor = useColorModeValue('gray.800', 'white');
  
  return (
    <Box bg={footerBg} color={textColor}>
      <Container as={Stack} maxW={'6xl'} py={10}>
        <SimpleGrid
          templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr 2fr' }}
          spacing={8}>
          
          <Stack spacing={6}>
            <Box>
              <Image src={Logo} alt="Logo" h="80px" w="auto"/>
            </Box>
            <Text fontSize={'sm'}>
              © {new Date().getFullYear()} Hetep Iaout Services. Tous droits réservés.
            </Text>
            <Stack direction={'row'} spacing={6}>
              <SocialButton label={'Facebook'} href={'https://www.facebook.com/his2015/?locale=fr_FR'}>
                <FaFacebook />
              </SocialButton>
              <SocialButton label={'Instagram'} href={'https://www.instagram.com/hetepiaoutservices/'}>
                <FaInstagram />
              </SocialButton>
              <SocialButton label={'TikTok'} href={'https://www.tiktok.com/@his1562'}>
                <FaTiktok />
              </SocialButton>
              <SocialButton label={'LinkedIn'} href={'https://www.linkedin.com/company/hetepiaoutservices/'}>
                <FaLinkedin />
              </SocialButton>
            </Stack>
          </Stack>

          <Stack align={'flex-start'}>
            <Heading fontSize="lg" mb={2} color={headingColor}>Liens rapides</Heading>
            <FooterLink to="/">Accueil</FooterLink>
            <FooterLink to="/demande-de-devis">Devis</FooterLink>
            <FooterLink to="/recrutement">Nous recrutons</FooterLink>
            <FooterLink to="/NosPartenaires">Nos Partenaires</FooterLink>
            {/* ✅ Ajout de la page Ressources ici */}
            <FooterLink to="/NosRessources">Nos Ressources</FooterLink> 
          </Stack>

          <Stack align={'flex-start'}>
            <Heading fontSize="lg" mb={2} color={headingColor}>Contact</Heading>
            <Text fontSize="sm">Téléphone: 01 43 52 64 23</Text>
            <Text fontSize="sm">Email: his@donnerlavieauxannees.com</Text>
            <FooterLink to="/mentions-legales">Mentions légales</FooterLink>
            <FooterLink to="/politique-de-confidentialite">Politique de confidentialité</FooterLink>
          </Stack>

          <Stack align={'flex-start'}>
            <Heading fontSize="lg" mb={2} color={headingColor}>Newsletter</Heading>
            <Text fontSize="sm">Restez à jour avec nos dernières nouvelles.</Text>
            <Stack as="form" direction={'row'} onSubmit={handleNewsletterSubmit} w="full">
              <Input
                placeholder={'Votre e-mail'}
                bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
                border={0}
                _focus={{ bg: 'whiteAlpha.300' }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <IconButton
                colorScheme="yellow"
                aria-label="S'abonner"
                type="submit"
                isLoading={loading}
                icon={<FaPaperPlane />}
              />
            </Stack>
          </Stack>
          
        </SimpleGrid>
      </Container>
    </Box>
  );
}

// Composants internes (SocialButton et FooterLink)
const SocialButton = ({ children, label, href }) => {
    return (
      <IconButton
        as="a"
        href={href}
        target="_blank" // ✅ Ouvre dans un nouvel onglet
        rel="noopener noreferrer"
        aria-label={label}
        bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
        rounded={'full'}
        size="lg"
        _hover={{ bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200') }}
        icon={children}
      />
    );
};
  
const FooterLink = ({ to, children }) => {
    const linkHoverColor = useColorModeValue('blue.500', 'yellow.400');
    return (
      <Link as={RouterLink} to={to} _hover={{ textDecoration: 'underline', color: linkHoverColor }}>
        {children}
      </Link>
    );
};

export default Footer;